import React from "react";
import { Box, Chip, Tooltip } from "@mui/material";
import { Info as InfoIcon } from "@mui/icons-material";

const VersionInfo = () => {
  const buildTime = process.env.REACT_APP_BUILD_TIME;
  const gitCommit = process.env.REACT_APP_GIT_COMMIT;

  // Development ortamında da göster
  if (!buildTime && !gitCommit) {
    return (
      <Box
        sx={{
          position: "fixed",
          bottom: 8,
          right: 8,
          zIndex: 1000,
          display: "flex",
          alignItems: "center",
          gap: 1,
          opacity: 0.7,
          "&:hover": {
            opacity: 1,
          },
        }}
      >
        <Chip
          label="Dev Mode"
          size="medium"
          variant="filled"
          sx={{
            fontSize: "0.9rem",
            height: 32,
            backgroundColor: "#ffeb3b",
            color: "#000",
            fontWeight: "bold",
          }}
        />
      </Box>
    );
  }

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: 8,
        right: 8,
        zIndex: 1000,
        display: "flex",
        alignItems: "center",
        gap: 1,
        opacity: 0.7,
        "&:hover": {
          opacity: 1,
        },
      }}
    >
      {gitCommit && (
        <Tooltip title={`Git Commit: ${gitCommit}`}>
          <Chip
            label={`v${gitCommit}`}
            size="small"
            variant="outlined"
            sx={{ fontSize: "0.7rem", height: 20 }}
          />
        </Tooltip>
      )}

      {buildTime && (
        <Tooltip
          title={`Build Time: ${new Date(buildTime).toLocaleString("tr-TR")}`}
        >
          <Chip
            icon={<InfoIcon sx={{ fontSize: "0.8rem" }} />}
            label={new Date(buildTime).toLocaleDateString("tr-TR")}
            size="small"
            variant="outlined"
            sx={{ fontSize: "0.7rem", height: 20 }}
          />
        </Tooltip>
      )}
    </Box>
  );
};

export default VersionInfo;
